import './Manufacturer.css';

function Manufacturer(props) {
    return (
        <div className='container-produttori'>
            <input type="checkbox" name={props.manufacturer} checked={props.selected} onChange={() => props.onSelect(props.manufacturer)}/>
            <label htmlFor={props.manufacturer}>{props.manufacturer}</label>
        </div>
    );
}

export default Manufacturer;